import { observer } from "mobx-react-lite";
import { memo, useCallback } from "react";

import { useBlock } from "./block-store";
import { useIsReadonly } from "./readonly-context";
import ValidatedField from "./ValidatedField";

import { Input } from "@/components/ui/input";

const DefaultFieldsComponent = () => {
  const block = useBlock();
  const isReadonly = useIsReadonly();

  // Stable callback to prevent unnecessary re-renders
  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      block.setNameFromUser(e.target.value);
    },
    [block],
  );

  return (
    <ValidatedField name="Step Name" path="name">
      <Input
        type="text"
        placeholder="Step Name"
        value={block.name || ""}
        onChange={handleNameChange}
        className="w-full"
        disabled={isReadonly}
      />
    </ValidatedField>
  );
};

const DefaultFields = memo(observer(DefaultFieldsComponent));

DefaultFields.displayName = "DefaultFields";

export default DefaultFields;
